/**
 * 腾讯云 SCF 接口的 Description 字段存在字符白名单限制。
 * 实测 em-dash（U+2014）会被拒绝，报 InvalidParameterValue.Description（"取值与规范不符"）。
 *
 * 规范化策略：
 * - 仅保留已实测安全的字符：ASCII 可打印字符 + 日文假名 + CJK 表意文字
 * - 其余字符（破折号、弯引号、emoji、全角/CJK 标点等）统一替换为 '-'
 * - 换行/制表符先转空格并折叠连续空白
 * - 截断至 256 字符（对齐腾讯云字段上限）
 */
export function sanitizeDescription(input: string): string {
  return input
    .replace(/[\r\n\t]/g, ' ')
    .replace(/[^\x20-\x7E\u3040-\u30FF\u4E00-\u9FFF]/gu, '-')
    .replace(/\s+/g, ' ')
    .replace(/-{2,}/g, '-')
    .trim()
    .slice(0, 256)
}
